import BeginnersGuide from '../../../Academy/BeginnersGuide/BeginnersGuide';
import useTutorialsBeginnersGuide from '../../../Academy/BeginnersGuide/hooks/useTutorialsBeginnersGuide';

function TutorialsBeginnersGuidePage() {
    const { activeStepIndex, beginnersGuideContextValue } = useTutorialsBeginnersGuide();

    return <BeginnersGuide
        activeStepIndex={activeStepIndex}
        beginnersGuideContextValue={beginnersGuideContextValue}
    />
}

export default TutorialsBeginnersGuidePage;
